import { WidgetIds, TfsCommands } from "Dashboards/Scripts/Generated/Constants";

export var QueryScalar_WidgetTypeID: string = WidgetIds.QueryScalarContribution;
export var CodeScalar_WidgetTypeID: string = WidgetIds.CodeScalarContribution;
export var WITChart_WidgetTypeID: string = WidgetIds.WITChartContribution;
export var Markdown_WidgetTypeID: string = WidgetIds.MarkDownContribution;
export var TCMChart_WidgetTypeID: string = WidgetIds.TCMChartContribution;
export var BuildChart_WidgetTypeID: string = WidgetIds.BuildChartContribution;
export var TestResults_FailureTrend_WidgetTypeId: string = WidgetIds.TestResultsFailureTrendContribution;
export var TestResults_DurationTrend_WidgetTypeId: string = WidgetIds.TestResultsDurationTrendContribution;
export var TestResults_Trend_WidgetTypeId: string = WidgetIds.TestResultsTrendContribution;

export var Dashboards_Source_Area: string = "Dashboards";
export var WITChart_Source_Area: string = "WIT Chart";
export var TCMChart_Source_Area: string = "TCM Chart";
export var QueryTree_Source_Area: string = "WIT Query";
export var CodeExplorer_Source_Area: string = "Source Explorer";
export var CodeMD_Source_Area: string = "Code Markdown";
export var Build_Source_Area: string = "Build";
export var Test_Source_Area: string = "Test Management";

export var PinToDashboardCommand: string = TfsCommands.PinToDashboard;
